import { useState } from "react";
import supabase from '../supabaseClient';

// ── Cuota de 40 descargas/mes del plan FREE ───────────────────────
// Antepone la comprobación de cuota (Edge Function registrar-descarga-free)
// a la generación del PDF. El contador vive en Supabase (cuentas), no en
// el navegador, para que no se pueda saltar limpiando caché.

export const useDescargaFree = () => {
  const [generando, setGenerando] = useState(false);
  const [bloqueo, setBloqueo] = useState(null); // { resetDate } | null

  const intentarDescarga = async (generarPdf) => {
    setGenerando(true);
    setBloqueo(null);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const r = await fetch("https://fmzyvyhgqhrpfpsdwtcu.supabase.co/functions/v1/registrar-descarga-free", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${session?.access_token}` },
      });
      const data = await r.json().catch(() => ({}));

      if (!r.ok) {
        setBloqueo({ resetDate: data.reset_date || null });
        return;
      }

      await generarPdf();
    } catch {
      setBloqueo({ resetDate: null });
    } finally {
      setGenerando(false);
    }
  };

  return { intentarDescarga, generando, bloqueo, cerrarBloqueo: () => setBloqueo(null) };
};
